import { render } from "./TerimaKasihIsiFormulir.vue?vue&type=template&id=cb6684ba"
import script from "./TerimaKasihIsiFormulir.vue?vue&type=script&lang=js"
export * from "./TerimaKasihIsiFormulir.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__